/** Scrollable filter option list — shared by Fleet Manager, Reports, and Exploration. */
export const FILTER_SCROLLABLE_LIST_CLASS =
  'max-h-[calc(100vh-600px)] side-panel-scrollbar overflow-y-auto';

/** Outer shell for filter option rows (padding, background, flex column). */
export const FILTER_OPTION_LIST_SHELL_CLASS =
  'mt-2 bg-white z-20 flex flex-col pb-2';
